import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { submitDrillResult, getDrillStats, percentile } from '../lib/results.js';
import { useAuth } from '../lib/auth.jsx';
import { Sparkles, ArrowRight } from './Icons.jsx';

// Drop-in at the top of any drill's Done screen.
// Submits the result, fetches aggregate stats, and shows a percentile + signup CTA.
export default function DrillResultBar({ slug, score, maxScore, accuracyPct, metadata }) {
  const { user, configured } = useAuth();
  const [stats, setStats] = useState(null);
  const [submitState, setSubmitState] = useState('idle');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setSubmitState('submitting');
      await submitDrillResult(slug, { score, maxScore, accuracyPct, metadata });
      if (cancelled) return;
      setSubmitState('done');
      const s = await getDrillStats(slug);
      if (!cancelled) setStats(s);
    })();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  const pct = stats?.configured && stats.count > 5 ? percentile(stats, accuracyPct ?? score) : null;

  if (!configured && submitState !== 'done') return null;

  return (
    <section className="card" style={{
      marginBottom: 18, padding: '14px 18px',
      background: 'linear-gradient(135deg, var(--brand-deep), var(--brand-purple))',
      color: '#fff', border: 'none'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap' }}>
        <div style={{ flex: 1, minWidth: 220 }}>
          {pct !== null ? (
            <>
              <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.12em', opacity: 0.85 }}>Where you placed</div>
              <strong style={{ fontSize: 22, display: 'block', lineHeight: 1.2 }}>
                {pct <= 10 ? 'Top 10%' : pct <= 25 ? 'Top 25%' : pct <= 50 ? 'Top 50%' : `Top ${pct}%`}
                <span style={{ fontSize: 13, fontWeight: 500, opacity: 0.85, marginLeft: 8 }}>of {stats.count} users</span>
              </strong>
            </>
          ) : (
            <>
              <div style={{ fontSize: 11, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.12em', opacity: 0.85 }}>Score saved</div>
              <strong style={{ fontSize: 16, display: 'block', lineHeight: 1.3 }}>
                {user ? 'Result added to your account' : configured ? 'Sign in to track your progress across devices' : 'Saved locally in your browser'}
              </strong>
              {stats && stats.count > 0 && stats.count <= 5 && (
                <span style={{ fontSize: 12.5, opacity: 0.8 }}>Percentile unlocks once {6 - stats.count} more results land in this drill.</span>
              )}
            </>
          )}
        </div>
        {!user && configured && (
          <Link to="/signup" className="btn" style={{ background: '#fff', color: 'var(--brand-deep)', textDecoration: 'none' }}>
            <Sparkles width="14" height="14" />Save my progress <ArrowRight width="14" height="14" />
          </Link>
        )}
      </div>
    </section>
  );
}
